<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
        <wt-form-table-list ref="payTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
          <template slot="value" slot-scope="scope">
            <span v-if="currentIndex !== scope.index">{{ scope.row.value }}</span>
            <el-input v-if="currentIndex === scope.index" size="small" v-model="currentValue"></el-input>
          </template>
          <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
            <wt-auth class="search-form-btn">
              <el-button v-if="currentIndex !== scope.index" size="mini" :type="'primary'" @click="toClickAction(scope, 'EDIT')">编辑</el-button>
              <el-button v-if="currentIndex === scope.index" size="mini" :type="'primary'" @click="toClickAction(scope, 'SAVE')">保存</el-button>
              <el-button v-if="currentIndex === scope.index" size="mini" :type="'primary'" @click="toClickAction(scope, 'CANCEL')">取消</el-button>
            </wt-auth>
          </template>
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <wt-detail-page :visible.sync="consumablesVisible" :component-name="'SiteGoodsCList'" component-type="edit" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SiteGoodsViewHistory',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_WARNINGPARAMSSETTING',
        formComponent: {
          list: { type: 'default', value: '/modules/siteGoods/siteGoodsHistoryList', params: {}}
        },
        formInputsData: [{ name: '修改时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '操作用户', key: 'operateUserName', value: '', type: 'text' }],
        formButtonsData: [],
        formTableData: [
          { name: '修改前库存数', key: 'preInventory', type: 'text' },
          { name: '修改后库存数量', key: 'aftInventory', type: 'text' },
          { name: '备注', key: 'remark', type: 'text' },
          { name: '操作人', key: 'operateUserName', type: 'text' },
          { name: '修改时间', key: 'updateTime', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      currentIndex: -1,
      currentValue: '',
      detailFormButtons: {
        title: '站点商品',
        elements: [{ name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      consumablesVisible: false
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.detailFormData.id
    this.form.formComponent.list.params.goodsId = this.goodsDetailData.goodsId
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '修改历史' }})
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    onButtonAction(data) {
    },
    toClickAction({ row, index }, type) {
      if (type === 'EDIT') {
        this.currentValue = row.value
        this.currentIndex = index
      }
      if (type === 'SAVE') {
        row.value = this.currentValue
        this.currentIndex = -1
      }
      if (type === 'CANCEL') {
        this.currentIndex = -1
      }
      console.log(index)
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.siteManage.siteDetailData,
      goodsDetailData: state => state.siteManage.siteGoodsDetailData
    })
  }
}
</script>

<style>
</style>
